/**
 * Notify component
 */

// React
import React, { FC, useEffect } from 'react';

// Libraries
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Material
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

// Recoil
import { notifyAtom } from 'recoil/NotifyRecoil';

// Utils
import { NOTIFICATION_MESSAGES, TIME_AUTO_CLOSE_NOTIFY } from 'utils/constants';

const NotifyContainer = styled(Box)<{ severity: string }>(({ severity, theme }) => ({
  width: '100%',
  height: '47px',
  color: '#ffffff',
  padding: '16px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: '10px',
  backgroundColor: severity === 'success' ? theme.palette.success.light : theme.palette.error.light,
  marginBottom: '33px',
}));

// Component
const NotifyComponent: FC = () => {
  const {
    open,
    title = NOTIFICATION_MESSAGES.SUCCESS.DELETE,
    severity = 'success',
  } = useRecoilValue(notifyAtom);
  const setSnackNotify = useSetRecoilState(notifyAtom);

  const handleClose = () => {
    setSnackNotify((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (open) {
      timer = setTimeout(() => {
        handleClose();
      }, TIME_AUTO_CLOSE_NOTIFY);
    }

    return () => clearTimeout(timer);
  }, [open, handleClose]);

  if (!open) return null;

  return (
    <NotifyContainer severity={severity}>
      <Typography>{title}</Typography>
      <IconButton onClick={handleClose} size="small">
        <CloseIcon sx={{ width: '13px', height: 'auto', color: '#AAAAAA' }} />
      </IconButton>
    </NotifyContainer>
  );
};

export default NotifyComponent;
